module.exports = __webpack_public_path__ + "img/svg61.4e326c03.svg";